<template lang="pug">
  .report
    .option
      PTextField(v-model="reportOptions.numExtraTime50" label="Número de horas extras normais" type="number" parser="float")
      PTextField(v-model="reportOptions.numExtraTime100" label="Número de horas extras extraordinárias" type="number" parser="float")
      PTextField(v-model="reportOptions.numExtraTimeSpecial" label="Número de horas extras especiais" type="number" parser="float")

    .option2
      span orientação pdf
      PRadio(label="retrato", v-model="reportOptions.orientation", option="portrait")
      PRadio(label="paisagem", v-model="reportOptions.orientation", option="landscape")

    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") gerar pdf

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        numExtraTime50: 2,
        numExtraTime100: 2,
        numExtraTimeSpecial: 2,
        orientation: 'portrait'
      }
    }
  },
  methods: {
    async generate (reportType) {
      this.loading = true

      let result

      try {
        result = await this.$API.R16.save({
          entity: this.reportInfo.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          startDate: moment(this.reportInfo.periodData.startDate).format('DD/MM/YYYY'),
          endDate: moment(this.reportInfo.periodData.endDate).format('DD/MM/YYYY')
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px;

  .option {
    display: grid;
    grid-auto-flow: column;
    grid-column: 1/3;
    grid-column-gap: 10px;
  }

  .option2 {
    span {grid-column: 1/3}

    grid-row: 2/3;
    display: grid;
    grid-column: 1/2;
    grid-template-columns: max-content max-content;
    grid-column-gap: 30px;
  }

  .button {
    grid-row: 3/3;
    grid-column: 1/3;

    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
